import { SandTableMapContainer } from '@components/SandTableMapContainer';
import {
  $GateSandtableBatchMode,
  $GateSandtableGroupMode,
  $sandTableLoaded,
  $sandTableLoadedApi,
} from '@stores/sandTableStores';
import type { STMap } from '@types';
import { useStore } from 'effector-react';
import { useEffect, useRef } from 'react';
import { stEditorAmap } from '../STAMap';
import {
  onMapMarkerClick,
  onMarkerClickBatchMode,
  onMarkerClickGroupMode,
} from '../actions/onMarkerClick';
import { onMapMarkerMoveEnd } from '../actions/onMarkerMoveEnd';
import { onRadarRotate } from '../actions/onRadarRotate';
import { BatchAddTip } from '../components/BatchAddTip';
import { GroupCaptureWidget } from '../components/GroupCaptureWidget';
import { GroupWidget } from '../components/GroupWidget';
import { EditingTipWidget } from './EditingTipWidget';
import MapCaptureWidget from './MapCaptureWidget';
import MapEditorButtons from './MapEditorButtons';
import MapEditorSearch from './MapEditorSearch';
import MapMarkerWidgets from './MapMarkerWidgets';
import { MapZoomWidget } from './MapZoomWidget';

interface Props {
  data: STMap;
}

function SandTablePlayerMap({ data }: Props) {
  const loaded = useStore($sandTableLoaded);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    stEditorAmap.init({
      target: containerRef.current,
      initialView: data.initialView?.type === 1 ? data.initialView : undefined,
      mapStyle: data.layerStyle,
      onMarkerClick: handleMarkerClick,
      onMarkerMoveEnd: onMapMarkerMoveEnd,
      onRadarRotate,
      onLoaded: $sandTableLoadedApi.on,
    });
    return () => {
      stEditorAmap.removeMap();
      $sandTableLoadedApi.off();
    };
  }, [data.id]);

  const handleMarkerClick = (id: string) => {
    if ($GateSandtableGroupMode.state.getState()) {
      onMarkerClickGroupMode(id);
    } else if ($GateSandtableBatchMode.state.getState()) {
      onMarkerClickBatchMode(id);
    } else {
      onMapMarkerClick(id);
    }
  };

  return (
    <>
      <SandTableMapContainer
        className="absolute inset-0 flex items-center justify-center rounded"
        ref={containerRef}
      />
      {loaded && (
        <>
          <MapMarkerWidgets />
          <MapEditorSearch />
          <MapCaptureWidget />
          <MapEditorButtons />
          <BatchAddTip />
          <EditingTipWidget />
          <MapZoomWidget />
          <GroupCaptureWidget />
          <GroupWidget />
        </>
      )}
    </>
  );
}

export default SandTablePlayerMap;
